import { useMemo } from 'react'
import _ from 'lodash'
import { useFormSelector } from '../../../redux/formStoreHooks'
import L3ValidationSummary, { L3ValidationSummarySection } from '../l3/L3ValidationSummary'
import { selectForm } from '../../../redux/selectForm'
import { xpathPageIdx, ConceptStatusValidityInfo, ValiditySeverity } from '@fusion-advantage/formlib'

const L4ValidationSummary = () => {
	const { concepts } = useFormSelector(state => selectForm(state))
	const validities = useFormSelector(state => state.form.conceptStatusValidity)
	const { pages } = useFormSelector(selectForm)
	const sections = useMemo(() => {
		const sections: L3ValidationSummarySection[] = pages.map(({ title }) => ({
			title: String(title),
			validities: [],
		}))
		const unknownSection: L3ValidationSummarySection = {
			title: 'Unknown Page',
			validities: [],
		}
		_.forEach(validities, (validity, cid) => {
			const concept = concepts[cid]
			let pageIdx: number|null = null
			if(concept.xpaths.length > 0) {
				pageIdx = xpathPageIdx(concept.xpaths[0])
			}
			const validityInfo = new ConceptStatusValidityInfo(validity)
			switch(validityInfo.severity) {
				case ValiditySeverity.Success:
					break
				default:
					const section = pageIdx !== null ? sections[pageIdx] : unknownSection
					section.validities.push({
						validity,
						concept,
					})
			}
		})
		if(unknownSection.validities.length > 0) {
			sections.push(unknownSection)
		}
		// console.debug(`[L3ValidationSummary]`, {validities, sections})
		return sections
	}, [pages, concepts, validities])
	return (
		<L3ValidationSummary sections={sections} />
	)
}

export default L4ValidationSummary
